import { ROLES } from "./permissions";

/** Alinhado aos módulos do backend (preHandler `is(...)`). */

export const ROLES_ORCAMENTO = [
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER_FIN,
] as const;

export const ROLES_COMUNICADOS = [
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_ORGANIZADOR,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER,
] as const;

export const ROLES_FINANCEIRO = [
  ROLES.ROLE_USER_FIN,
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER_GER,
] as const;

export const ROLES_LOJA_OPERACIONAL = [
  ROLES.ROLE_USER_FIN,
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER,
] as const;

export const ROLES_EVENTO_COMPARTILHAMENTO = [
  ROLES.ROLE_USER,
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_ORGANIZADOR,
  ROLES.ROLE_USER_ORG,
] as const;

export const ROLES_RESULTADOS = [
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER_FIN,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER,
  ROLES.ROLE_ORGANIZADOR,
  ROLES.ROLE_USER_ORG,
  ROLES.ROLE_USER_CRO,
] as const;

export const ROLES_INSCRICOES_GER = [
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER_FIN,
] as const;

/** Painel geral: perfis operacionais com PERMISSION_VIEW no seed. */
export const ROLES_PAINEL_VIEW = [
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER_FIN,
  ROLES.ROLE_USER_CRO,
  ROLES.ROLE_USER_ORG,
  ROLES.ROLE_ORGANIZADOR,
] as const;

/** Cadastros (menu e telas de gestão). */
export const ROLES_CADASTROS = [
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
  ROLES.ROLE_USER,
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_USER_FIN,
  ROLES.ROLE_USER_CRO,
  ROLES.ROLE_USER_ORG,
  ROLES.ROLE_ORGANIZADOR,
] as const;

export const ROLES_CONFIGURACOES = [
  ROLES.ROLE_USER_GER,
  ROLES.ROLE_ADMIN,
  ROLES.ROLE_MASTER,
] as const;
